'use client';

import { DashboardData } from '@/types/api';
import VesselConditionChart from './vessel-condition-chart';

interface ChartsSectionProps {
  data: DashboardData;
}

export default function ChartsPieSection({ data }: ChartsSectionProps) {
  const cond = data?.latest_vessel_condition;
  const hasAdvanced = Boolean(
    cond && (cond.ongoing !== undefined || cond.maneuver !== undefined || cond.stopped !== undefined)
  );

  const ongoing = hasAdvanced ? (cond.ongoing ?? 0) : (cond?.sail ?? 0);
  const maneuver = hasAdvanced ? (cond.maneuver ?? 0) : 0;
  const stopped = hasAdvanced ? (cond.stopped ?? 0) : (cond?.running ?? 0);

  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl p-5 shadow-sm border border-gray-200 dark:border-gray-800 h-full flex flex-col justify-between">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 pb-3 border-b border-gray-100 dark:border-gray-800">
        <div>
          <h3 className="font-semibold text-gray-900 dark:text-white tracking-tight">
            Latest Vessel Condition
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Proporsi armada: Ongoing (berlayar), Maneuver (olah gerak), Stopped (bersandar)
          </p>
        </div>

        {/* Status mini badges */}
        <div className="flex items-center gap-1.5 flex-wrap shrink-0">
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-semibold bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 border border-emerald-200/50">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
            {ongoing} Ongoing
          </span>
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-semibold bg-amber-50 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300 border border-amber-200/50">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
            {maneuver} Maneuver
          </span>
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-semibold bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 border border-gray-200/50">
            <span className="w-1.5 h-1.5 rounded-full bg-gray-400" />
            {stopped} Stopped
          </span>
        </div>
      </div>

      <div className="mt-2 flex-1 flex items-center justify-center">
        <VesselConditionChart data={data.latest_vessel_condition} />
      </div>
    </div>
  );
}
